import { createStore, compose, applyMiddleware } from "redux";
import reduxImmutableStateInvariant from "redux-immutable-state-invariant";
import thunk from "redux-thunk";
import { createBrowserHistory } from "history";
// 'routerMiddleware': dispatches router actions (push/replace/...) to history.
import { routerMiddleware } from "connected-react-router";
import mqttMiddleware from "./middleware/mqttMiddleware";
import { loadingBarMiddleware } from "react-redux-loading-bar";

import createRootReducer from "@common/reducers";
export const history = createBrowserHistory();
function configureStoreProd(initialState) {
  const reactRouterMiddleware = routerMiddleware(history);
  const middlewares = [
    // Add other middleware on this line...

    // thunk middleware can also accept an extra argument to be passed to each thunk action
    // https://github.com/gaearon/redux-thunk#injecting-a-custom-argument
    thunk,
    reactRouterMiddleware,
    mqttMiddleware,
    loadingBarMiddleware(),
  ];

  return createStore(
    createRootReducer(history),
    initialState,
    compose(applyMiddleware(...middlewares)),
  );
}

function configureStoreDev(initialState) {
  const reactRouterMiddleware = routerMiddleware(history);
  const middlewares = [
    // Add other middleware on this line...

    // Redux middleware that spits an error on you when you try to mutate your state either inside a dispatch or between dispatches.
    reduxImmutableStateInvariant(),

    // thunk middleware can also accept an extra argument to be passed to each thunk action
    // https://github.com/gaearon/redux-thunk#injecting-a-custom-argument
    thunk,
    reactRouterMiddleware,
    mqttMiddleware,
    loadingBarMiddleware(),
  ];

  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // add support for Redux dev tools
  const store = createStore(
    createRootReducer(history),
    initialState,
    composeEnhancers(applyMiddleware(...middlewares)),
  );

  if (import.meta.hot) {
    // Enable Vite hot module replacement for reducers
    import.meta.hot.accept("../common/reducers", (newModule) => {
      store.replaceReducer(newModule.default(history));
    });
  }

  return store;
}

const configureStore =
  "production" === "production"
    ? configureStoreProd
    : configureStoreDev;

export default configureStore;
